import createDocumentData from "../../utils/createDocumentData";

import { DiscussionChannel } from "./types/DiscussionChannel";

export default function createDiscussionChannelData(firebase, data) {
	if (data.users) {
		data.userIds = data.users.map(({ id }) => id);
	}

	return DiscussionChannel.parse(createDocumentData(firebase, "discussionChannels", data));
}
